import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/content';
import { CTAButton } from './CTAButton';
export function BonusSection() {
  return <section className="bg-brand-navy px-4 py-5 text-white sm:px-6" aria-labelledby="bonus-heading" data-id="element-22" data-mp="1oi811bi6d428">
      <div className="mb-3 text-center" data-id="element-23" data-mp="1ye1p9s59alzu">
        <h2 id="bonus-heading" className="mb-1 font-heading text-xl uppercase leading-tight sm:text-3xl" data-id="element-24" data-mp="1yf30pxq6pai3">
          🎁 5 Bonus Premium inclus
        </h2>
        <p className="mx-auto max-w-xl text-[12px] font-medium leading-snug text-white/85 sm:text-sm" data-id="element-25" data-mp="15pw0mub30cuq">
          En plus de PADEL COACH READY™, vous recevrez 5 Bonus Premium spécialement conçus pour vous
          faire gagner encore plus de temps et enrichir votre travail tout au long de la saison.
        </p>
      </div>
      <div className="mx-auto max-w-xl space-y-2" data-id="element-26" data-mp="qz5bju0vjrvb">
        {bonuses.map(bonus => <article key={bonus.label} className="rounded-lg border border-brand-green/40 bg-white/5 p-3" data-id="element-27" data-mp="mxtjlhuj2ujy">
            <div className="mb-1 flex items-start gap-2" data-id="element-28" data-mp="29q0cgujbbw6g">
              <GiftIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-green" aria-hidden="true" data-id="element-29" data-mp="2eq4ljzhw5omn" />
              <h3 className="font-heading text-[13px] uppercase leading-tight sm:text-base" data-id="element-30" data-mp="2jixochtsumw3">
                <span className="text-brand-green" data-id="element-31" data-mp="2oh91p2jazfj2">{bonus.label}</span> — {bonus.title}
              </h3>
            </div>
            <p className="text-[11px] font-medium leading-snug text-white/80 sm:text-xs" data-id="element-32" data-mp="1qus3lv2qwxw9">
              {bonus.description}
            </p>
          </article>)}
      </div>
      <div className="mx-auto mt-3 max-w-md" data-id="element-33" data-mp="20qdaa6iremcc">
        <CTAButton data-id="element-34" data-mp="20trelkazh5mf">🚀 OUI ! JE VEUX MON SYSTÈME MAINTENANT</CTAButton>
      </div>
    </section>;
}